import React from 'react';
import type { MSlotProps } from './MSlot.types';
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';
import clsx from 'clsx';

/**
 * @description This renders a Generic parsys component
 * @returns {React.ReactElement}
 */
export const MSlot: React.FC<MSlotProps> = props => {
  const {
    pagePath,
    itemPath,
    isAuthorMode = false,
    cqItems = {},
    className = '',
    containerClassName = '',
    model,
    aemReactComponentMapping = {},
  } = props;

  if (isAuthorMode) {
    return (
      <div className={clsx('m-slot', containerClassName)} data-test={JSON.stringify({ pagePath, itemPath })}>
        <div className={className}>
          <ResponsiveGrid
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            pagePath={pagePath}
            itemPath={itemPath}
            columnCount="12"
            gridClassNames={''}
            config={{
              isEmpty: () => true,
              resourceType: 'mi-aem-common-spa/components/container',
            }}
          />
        </div>
      </div>
    );
  }

  const renderComponents = () => {
    const components: React.ReactNode[] = [];
    const itemOrder = model?.[':order'] || Object.keys(cqItems);

    itemOrder.forEach((itemKey: string) => {
      const item = cqItems[itemKey];
      const Component = aemReactComponentMapping[item?.[':type']];
      components.push(Component ? <Component key={itemKey} {...item} /> : null);
    });

    return components;
  };

  return (
    <div className={clsx('m-slot', containerClassName)} data-test={JSON.stringify({ pagePath, itemPath })}>
      <div className={className}>{renderComponents()}</div>
    </div>
  );
};

export default MSlot;
